import { useAppDispatch } from 'appState/store'

import { ReusableModal } from 'components/Modals/ReusableModal'
import { updateHumanAgentCallInProgress } from 'features/calls/callsSlice'
import { IClaim } from 'features/claims/types'
import { FaPhoneVolume, FaTimes } from 'react-icons/fa'
import { Button } from '@outbound-ai/ursa'
import styled from 'styled-components'
import { formatPhoneNumber } from 'utils'

interface IProps {
  show: boolean
  setShow: React.Dispatch<React.SetStateAction<boolean>>
  phoneNumber: string
  startCall: () => void
  claim: IClaim
}

export const ClaimCallJobStandardModal = ({ show, setShow, phoneNumber, startCall, claim }: IProps) => {
  const dispatch = useAppDispatch()
  const payerPhoneNumber =
    formatPhoneNumber(phoneNumber || claim?.insurerPhoneNumber || '') ||
    phoneNumber ||
    claim?.insurerPhoneNumber ||
    'Unknown number'

  const handelCancel = () => {
    setShow(false)
  }

  const handeStartCall = () => {
    dispatch(updateHumanAgentCallInProgress({ callInProgress: true }))
    startCall()
    setShow(false)
  }

  return (
    <>
      <ReusableModal show={show} setShow={setShow} maxWidth={'431px'}>
        <Div className="user-select-none">
          <span role="button" className="close" onClick={handelCancel}>
            <FaTimes />
          </span>
          <div className="section-title">
            <h2 className="h1">
              <FaPhoneVolume /> Start manual call?
            </h2>
          </div>
          <div className="section-body">
            <p>{payerPhoneNumber}</p>
          </div>
          <div className="section-actions">
            <Button variant="primary-outline" radius="rounded" color="primary" onClick={handelCancel}>
              Cancel
            </Button>

            <div>
              <Button variant="success" className="w-100" radius="rounded" onClick={handeStartCall}>
                Dial {formatPhoneNumber(phoneNumber)}
              </Button>
            </div>
          </div>
        </Div>
      </ReusableModal>
    </>
  )
}

const Div = styled.div`
  padding: 1.5rem;
  text-align: center;
  background-color: ${({ theme }) => theme.colors.info.lightest};
  color: ${({ theme }) => theme.colors.primary.darker};
  .close {
    float: right;
    font-size: 1rem;
    svg {
      width: 1rem;
      height: 1rem;
    }
  }
  > .section-title {
    margin-top: 1rem;
    svg {
      width: 1.5rem;
      height: 1.5rem;
      margin-bottom: 1.25rem;
      color: ${({ theme }) => theme.colors.secondary.darker};
    }

    h2 {
      font-weight: ${({ theme }) => theme.fontWeight.bold};
      font-size: 24px;
    }
  }

  > .section-body {
    p {
      ${({ theme }) => theme.typography.h5.normal};
      color: ${({ theme }) => theme.colors.grey.dark};
    }
    span {
      ${({ theme }) => theme.typography.s.normal};
      color: ${({ theme }) => theme.colors.primary.dark};
    }
  }

  > .section-actions {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    gap: 0.75rem;
    margin-top: 1.5rem;

    > button:first-child svg {
      transform: rotate(-135deg);
    }

    > div:last-child {
      small {
        position: relative;
        top: -0.25rem;
        font-weight: ${({ theme }) => theme.fontWeight.normal};
        ${({ theme }) => theme.typography.xxs.normal};
        line-height: 160%;
      }
    }
  }
`
